"use client";

import { TTestimonySection } from "@shared/cms";
import { imageFallback } from "@shared/utils";
import Image from "next/image";

export function TestimonySection({ title, description, testimonies }: TTestimonySection) {
  return (
    <>
      <section className="py-14 md:py-24">
        <div className="container">
          <h4 className="text-2xl sm:text-4xl font-bold text-center">{title}</h4>
          {description && <div className="text-base sm:text-lg mt-4 text-gray-500 text-center">{description}</div>}
          <div className="mt-8 sm:mt-15 sm:columns-2 md:columns-3 sm:gap-6">
            {testimonies.map((testimony, index) => {
              return (
                <div className="border border-gray-200 p-6 rounded-xl break-inside-avoid mb-6" key={`${testimony.name}-${index}`}>
                  <div className="flex space-x-3">
                    {testimony.avatar && (
                      <Image
                        src={testimony.avatar.url}
                        alt={testimony.avatar.alternativeText || testimony.avatar.name || ""}
                        width={testimony.avatar.width || 40}
                        height={testimony.avatar.height || 40}
                        className="size-10 min-w-10 rounded-full overflow-hidden bg-white border-gray-200 border"
                        onError={imageFallback()}
                      />
                    )}
                    <div className="flex-1">
                      <div className="text-base font-bold">{testimony.name}</div>
                      <div className="text-sm text-gray-500">{testimony.jobPosition}</div>
                    </div>
                  </div>
                  <div className="mt-6">{testimony.testimony}</div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
